import loadable, { DefaultComponent, LoadableComponent } from '@loadable/component';
import AuthRoute from 'components/Router/AuthRoute';
import FallbackScreen from 'components/Router/FallbackScreen';
import PrivateRoute from 'components/Router/PrivateRoute';
import { ERROR_404_ROUTE } from 'constants/router';
import React from 'react';
import { Redirect, Route, Switch } from 'react-router-dom';



export interface IRouter {
  loader: () => Promise<DefaultComponent<any>>;
  path: string;
  exact: boolean;
  type: 'public' | 'private' | 'auth';
  layout: string;
}

interface IProps {
  routes: IRouter[];
}

export interface IRouteProps {
  path: string;
  exact: boolean;
  layout: string;
  component: LoadableComponent<any>;
}

const Router: React.FC<IProps> = ({ routes }) => {
  const routeSelector = (router: IRouter, key: number) => {
    const { path, exact, loader, type, layout } = router;
    const props: IRouteProps = {
      path,
      exact,
      layout,
      component: loadable(loader, { fallback: <FallbackScreen /> }),
    };
    if (type === 'private') {
      return <PrivateRoute key={key} {...props} />;
    }
    if (type === 'auth') {
      return <AuthRoute key={key} {...props} />;
    }
    return <Route key={key} {...props} />;
  };

  return (
    <Switch>
      {routes.map((router, index) => routeSelector(router, index))}
      <Redirect to={ERROR_404_ROUTE} />
    </Switch>
  );
};

export default Router;
